import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = ({ onGetQuoteClick }) => {
  return (
    <section id="home" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-gradient-to-br from-gray-900 via-[#1a2a4a] to-[#0f1a35]">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>

      {/* Animated glow orbs */}
      <div className="absolute top-20 left-10 w-64 h-64 rounded-full opacity-10 blur-3xl" style={{background: 'radial-gradient(circle, #2CC84B, transparent)'}} />
      <div className="absolute bottom-20 right-10 w-64 h-64 rounded-full opacity-10 blur-3xl" style={{background: 'radial-gradient(circle, #3F51B5, transparent)'}} />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#2CC84B]/20 backdrop-blur-sm border border-[#2CC84B]/30 text-[#2CC84B] px-4 py-2 rounded-full mb-8 animate-fade-in">
            <Sparkles className="w-4 h-4" />
            <span className="text-sm font-semibold">Trusted Solar EPC Partner Since 2016</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Switch to Solar &<br />
            <span className="bg-gradient-to-r from-[#2CC84B] via-[#00BCD4] to-[#3F51B5] bg-clip-text text-transparent">
              Save Up to 80%
            </span>
            <br />
            on Electricity Bills
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Trusted Solar EPC Solutions for Homes & Businesses across India
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button
              onClick={onGetQuoteClick}
              size="lg"
              className="ep-shimmer-btn text-white text-lg px-8 py-6 rounded-lg font-bold shadow-xl ep-glow-green"
            >
              Get Free Solar Quote
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              onClick={() => {
                const element = document.querySelector('#process');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-[#00BCD4]/50 text-white hover:bg-[#00BCD4]/20 text-lg px-8 py-6 rounded-lg transition-all duration-300"
            >
              How It Works
            </Button>
          </div>

          {/* Key Benefits */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 hover:bg-white/20 hover:border-[#2CC84B]/50 hover:shadow-[0_0_20px_rgba(44,200,75,0.2)] transition-all duration-300">
              <p className="text-2xl font-bold text-[#2CC84B] mb-1">₹0</p>
              <p className="text-sm text-gray-300">EMI Available</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 hover:bg-white/20 hover:border-[#2CC84B]/50 hover:shadow-[0_0_20px_rgba(44,200,75,0.2)] transition-all duration-300">
              <p className="text-2xl font-bold text-[#2CC84B] mb-1">40%</p>
              <p className="text-sm text-gray-300">Govt Subsidy</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 hover:bg-white/20 hover:border-[#2CC84B]/50 hover:shadow-[0_0_20px_rgba(44,200,75,0.2)] transition-all duration-300">
              <p className="text-2xl font-bold text-[#2CC84B] mb-1">3-5 Yrs</p>
              <p className="text-sm text-gray-300">Fast ROI</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4 hover:bg-white/20 hover:border-[#2CC84B]/50 hover:shadow-[0_0_20px_rgba(44,200,75,0.2)] transition-all duration-300">
              <p className="text-2xl font-bold text-[#2CC84B] mb-1">25 Yrs</p>
              <p className="text-sm text-gray-300">Warranty</p>
            </div>
          </div>
        </div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-green-500/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-green-500/10 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>
    </section>
  );
};

export default Hero;
